import React from 'react';
import { Badge } from 'react-bootstrap';
import {
    FaArrowLeft,
    FaMapMarkerAlt,
    FaExternalLinkAlt,
    FaDoorOpen,
    FaBuilding,
    FaRulerCombined,
    FaBed,
    FaBath,
} from 'react-icons/fa';

/**
 * Inline property detail view shown when a property is selected.
 * Replaces the list in the side panel (in-place morph, no navigation).
 * Matches 1226 mobile PropertyDetailContent pattern.
 */
function PropertyDetail({ item, onBack, onOpenChannel }) {
    if (!item) return null;
    const priceStr = item.price != null ? `$${Number(item.price).toLocaleString()}` : 'Price TBD';
    const line2 = [item.city, item.state, item.postalCode].filter(Boolean).join(', ');
    const isOZ = item.opportunityZone;

    return (
        <div style={{ padding: '12px 14px' }}>
            {/* Back button */}
            <div
                onClick={onBack}
                style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    marginBottom: 12,
                    color: '#1a73e8',
                    fontSize: 13,
                }}
            >
                <FaArrowLeft /> Back to listings
            </div>

            {/* Address */}
            <div style={{ fontWeight: 700, fontSize: 16, color: '#222' }}>
                <FaMapMarkerAlt className="mr-1" style={{ color: '#d64545', fontSize: 14 }} />
                {item.address || '(no address)'}
            </div>
            <div style={{ color: '#777', fontSize: 13, marginTop: 2, marginBottom: 12 }}>{line2 || '-'}</div>

            {/* Price */}
            <div style={{ fontSize: 22, fontWeight: 700, color: '#1a73e8', marginBottom: 12 }}>{priceStr}</div>

            {/* Badges */}
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 14 }}>
                {item.propertyType && (
                    <Badge variant="light" style={{ fontSize: 12, color: '#555' }}>
                        <FaBuilding className="mr-1" /> {item.propertyType}
                    </Badge>
                )}
                {isOZ && (
                    <Badge variant="success" style={{ fontSize: 12 }}>
                        Opportunity Zone
                    </Badge>
                )}
                {item.zoning && (
                    <Badge variant="info" style={{ fontSize: 12 }}>
                        Zoned {item.zoning}
                    </Badge>
                )}
                {item.listingStatus && item.listingStatus !== 'unknown' && (
                    <Badge variant="secondary" style={{ fontSize: 12 }}>
                        {item.listingStatus}
                    </Badge>
                )}
            </div>

            {/* Placeholder fields (until Quinn enrichment) */}
            <div style={{ display: 'flex', gap: 20, marginBottom: 14, fontSize: 13, color: '#777' }}>
                <div>
                    <FaBed className="mr-1" /> Beds: -
                </div>
                <div>
                    <FaBath className="mr-1" /> Baths: -
                </div>
                <div>
                    <FaRulerCombined className="mr-1" /> Sqft: -
                </div>
            </div>

            {/* Source link */}
            {item.sourceUrl && (
                <a
                    href={item.sourceUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-secondary btn-sm"
                    style={{ fontSize: 13, padding: '5px 14px', marginRight: 8 }}
                >
                    <FaExternalLinkAlt className="mr-1" /> View Full Listing
                </a>
            )}

            {/* Open Channel */}
            {onOpenChannel && (
                <button
                    onClick={() => onOpenChannel(item)}
                    className="btn btn-primary btn-sm"
                    style={{ fontSize: 13, padding: '5px 14px' }}
                >
                    <FaDoorOpen className="mr-1" /> Open Channel
                </button>
            )}

            {/* Last seen */}
            {item.lastSeenAt && (
                <div style={{ marginTop: 12, fontSize: 11, color: '#aaa' }}>
                    Last seen: {new Date(item.lastSeenAt).toLocaleDateString()}
                </div>
            )}
        </div>
    );
}

export default PropertyDetail;
